/**
 * 订单协议类型枚举
 */
export enum AgreementType {
  ZHUANGYUAN = 'ZHUANGYUAN',
  NONZHUANGYUAN = 'NONZHUANGYUAN',
  NONAGREEMENT = 'NONAGREEMENT',
}

/**
 * 订单状态枚举
 */
export enum OrderStatus {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PENDING_ACCOMMODATION = 'PENDING_ACCOMMODATION',
  PENDING_CLASS_ALLOCATION = 'PENDING_CLASS_ALLOCATION',
  CLASS_ALLOCATED = 'CLASS_ALLOCATED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
}

/**
 * 报名步骤枚举
 */
export enum EnrollStep {
  inputtting = 'inputtting_userInfo',
  paying = 'paying',
  selecting = 'selectiong_room',
  allocating = 'allocating_class',
  end = 'allocated',
  refunded = 'refunded',
  canceled = 'canceled',
}

/**
 * 订单信息接口
 */
export interface Order {
  id: number
  user_id: number
  course_id: Course['courseId']
  position_code_id: PositionCode['id']
  user_name: string
  user_gender: string
  user_phone: string
  exam_score: string
  is_zhuangyuan: boolean
  region_id: regionType['id']
  order_status: OrderStatus
  class_id: number
  accommodationType: AccommodationType
  created_at: string
  updated_at: string
  agreement_type: AgreementType
  classQrCodeUrl: string
  courseName: string
  regionName: string
  positionCodeName: string
  expirationTime: string | null
}
export type remoteOrder = {
  orderId: number
  userId: number
  courseId: number
  courseName: string
  positionCodeId: number
  positionCodeName: string
  userName: string
  userGender: string
  userPhone: string
  examScore: string
  isZhuangyuan: boolean
  regionId: number
  regionName: string
  orderStatus: OrderStatus
  classId: number
  agreementType: AgreementType
  accommodationType: AccommodationType
  createdAt: string
  updatedAt: string
  classQrCodeUrl: string
  expirationTime: string | null
}

export const transformRemoteOrderToOrder = (remote: remoteOrder): Order => {
  return {
    id: remote.orderId,
    user_id: remote.userId,
    course_id: remote.courseId,
    position_code_id: remote.positionCodeId,
    user_name: remote.userName,
    user_gender: remote.userGender,
    user_phone: remote.userPhone,
    exam_score: remote.examScore,
    is_zhuangyuan: remote.isZhuangyuan,
    region_id: remote.regionId,
    order_status: remote.orderStatus,
    class_id: remote.classId,
    accommodationType: remote.accommodationType,
    agreement_type: remote.agreementType,
    created_at: remote.createdAt,
    updated_at: remote.updatedAt,
    classQrCodeUrl: remote.classQrCodeUrl,
    courseName: remote.courseName,
    positionCodeName: remote.positionCodeName,
    regionName: remote.regionName,
    expirationTime: remote.expirationTime,
  }
}
export enum AccommodationType {
  single = 'single',
  double = 'double',
}
/**
 * 职位代码信息接口
 */
export interface PositionCode {
  id: number
  name: string
  // hasInventory: 1 | 0
}

/**
 * 课程信息接口
 */
export interface Course {
  courseId: number
  courseName: string
  startTime: string
  endTime: string
  imageUrl: string
  courseDesc: string
  batchId: number
  region: regionType[]
}

/**
 * 协议信息接口
 */
export interface Agreement {
  label: string
  description?: string
  value: AgreementType
  signUrl?: string
}

/**
 * 地区信息类型
 */
export type regionType = {
  id: number
  name: string
  singlePrice: number
  introduction: string
  hasInventory: 1 | 0
}

/**
 * 轮播图 API 响应数据结构
 */
export interface CarouselApiResponse {
  /** 轮播图 ID */
  id: number
  /** 轮播图名称 */
  name: string
  /** 图片 URL */
  imageUrl: string
  /** 关联的课程 ID */
  courseId: number
  /** 课程名称 */
  courseName: string
  /** 排序顺序 */
  sortOrder: number
  /** 状态 (1: 启用, 0: 禁用) */
  status: number
  /** 创建时间 */
  createdTime: string | null,
  // 开始时间
  startTime : string,
  // 结束时间
  endTime: string,
}

/**
 * 图片对象接口，用于描述图片相关信息
 */
export interface CarouselObj {
  /** 图片 ID，唯一标识图片 */
  id: number
  /** 图片源地址，指向图片存储的原始路径 */
  src: string
  /** 图片所属课程 ID */
  courseId: Course['courseId']
  /** 图片优先级 */
  priority: number
  // 开始时间
  startTime: string,
  // 结束时间
  endTime: string
}

/**
 * 报名步骤到订单状态的映射对象
 */
export const EnrollStepToOrderStatus = {
  [EnrollStep.paying]: OrderStatus.PENDING_PAYMENT,
  [EnrollStep.selecting]: OrderStatus.PENDING_ACCOMMODATION,
  [EnrollStep.allocating]: OrderStatus.PENDING_CLASS_ALLOCATION,
  [EnrollStep.end]: OrderStatus.CLASS_ALLOCATED,
}

/**
 * 订单状态到报名步骤的映射对象
 */
export const OrderStatusToEnrollStep: Record<OrderStatus, EnrollStep | null> = {
  [OrderStatus.PENDING_PAYMENT]: EnrollStep.paying,
  [OrderStatus.PENDING_ACCOMMODATION]: EnrollStep.selecting,
  [OrderStatus.PENDING_CLASS_ALLOCATION]: EnrollStep.allocating,
  [OrderStatus.CLASS_ALLOCATED]: EnrollStep.end,
  [OrderStatus.CANCELLED]: EnrollStep.canceled,
  [OrderStatus.REFUNDED]: EnrollStep.refunded,
}

/**
 * 步骤配置数组
 */
export const STEPS_CONFIG = [
  { title: '填写信息' },
  { title: '支付费用' },
  { title: '选择住宿' },
  { title: '加入班级' },
]

/**
 * 表单数据类型
 */
export type DraftObj = {
  course_id: Course['courseId']
  position_code_id: PositionCode['id']
  region_id: regionType['id']
  name: string
  gender: '男' | '女'
  mobile: string
  score: string
  is_zhuangyuan: 'true' | 'false'
  agreement: Agreement['value'][]
  is_agree: boolean
}

import { type FormItemProps } from 'antd-mobile'

/**
 * 表单校验规则类型
 */
export type FormRules = Partial<Record<keyof DraftObj, FormItemProps['rules']>>

/**
 * 表单校验规则
 */
export const rules: FormRules = {
  position_code_id: [{ required: true, message: '请输入职位代码' }],
  region_id: [{ required: true, message: '请选择授课地点' }],
  name: [
    { required: true, message: '请输入姓名' },
    { max: 20, message: '姓名不能超过 20 个字符' },
  ],
  gender: [{ required: true, message: '请选择性别' }],
  mobile: [
    { required: true, message: '请输入手机号' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号' },
  ],
  score: [
    { required: true, message: '请输入笔试分数' },
    { pattern: /^\d+$/, message: '请输入有效的分数' },
  ],
  is_zhuangyuan: [{ required: true, message: '请选择是否守擂' }],
  agreement: [{ required: true, message: '请选择协议' }],
  is_agree: [{ required: true, message: '请先阅读并同意协议' }],
}
export type Favorite = {
  courseId: Course['courseId']
  courseName: Course['courseName']
}

export type remotePositionCodeList = {
  // positionId: number
  // name: string
  // batchId: number
  // inventory: number
  id: number
  name: string
  // hasInventory: 1 | 0
}[]

export const transformRemotePositionCodeListToPositionCodeList = (
  remote: remotePositionCodeList,
): PositionCode[] => {
  return remote.map((item) => ({
    id: item.id,
    name: item.name,
    // hasInventory: item.hasInventory,
  }))
}

/**
 * 将轮播图 API 响应数据转换为 CarouselObj 格式
 */
export const transformCarouselApiResponseToCarouselObj = (
  apiResponse: CarouselApiResponse[],
): CarouselObj[] => {
  return apiResponse.map((item) => ({
    id: item.id,
    src: item.imageUrl,
    courseId: item.courseId,
    priority: item.sortOrder,
    startTime: item.startTime,
    endTime: item.endTime
  }))
}
export const REFRESH_TOKEN_KEY = 'refresh_token'
export const ACCESS_TOKEN_KEY = 'access_token'
